import type { Database } from "@sk/db-types";
import { createClient } from "@supabase/supabase-js";
import { env } from "./env.ts";

// Lectures et écritures simples : directement vers Supabase, protégées par RLS.
export const supabase = createClient<Database>(env.supabaseUrl, env.supabaseAnonKey, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});

/** Connexion par e-mail : Supabase envoie un code à usage unique (SMTP Resend). */
export const sendEmailCode = (email: string) =>
  supabase.auth.signInWithOtp({ email, options: { shouldCreateUser: true } });

export const verifyEmailCode = (email: string, token: string) =>
  supabase.auth.verifyOtp({ email, token, type: "email" });

export const signInWithGoogle = () =>
  supabase.auth.signInWithOAuth({ provider: "google", options: { redirectTo: window.location.origin } });

/** Google activé côté Supabase ? Évite d'envoyer l'utilisateur sur une page d'erreur brute. */
export async function isGoogleEnabled(): Promise<boolean> {
  const res = await fetch(`${env.supabaseUrl}/auth/v1/settings`, {
    headers: { apikey: env.supabaseAnonKey },
  });
  if (!res.ok) return false;
  const settings = (await res.json()) as { external?: { google?: boolean } };
  return settings.external?.google === true;
}
